import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Gift, Check } from "lucide-react";

export default function ClaimGift() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [loading, setLoading] = useState(false);
  const [claimed, setClaimed] = useState(false);
  const [until, setUntil] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    document.title = "Seu presente: 1 mês de Pro grátis | MagnetLink";
  }, []);

  const claim = async () => {
    setLoading(true);
    setError(null);
    try {
      const { data, error } = await supabase.functions.invoke("claim-gift", {
        body: { token },
      });
      if (error) throw error;
      if (data?.error) throw new Error(data.error);
      setClaimed(true);
      setUntil(data?.granted_until ?? null);
    } catch (e: any) {
      setError("Não foi possível ativar o presente. O link pode ser inválido.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-hero flex items-center justify-center px-4">
      <Card className="w-full max-w-md text-center">
        <CardHeader>
          <div className="mx-auto w-14 h-14 rounded-2xl bg-gradient-primary flex items-center justify-center mb-2">
            {claimed ? (
              <Check className="h-6 w-6 text-primary-foreground" />
            ) : (
              <Gift className="h-6 w-6 text-primary-foreground" />
            )}
          </div>
          <CardTitle className="font-display">
            {claimed ? "Plano Pro ativado!" : "Você ganhou 1 mês de Pro"}
          </CardTitle>
          <CardDescription>
            {claimed
              ? until
                ? `Seu acesso Pro gratuito vale até ${new Date(until).toLocaleDateString("pt-BR")}.`
                : "Seu acesso Pro gratuito já está ativo."
              : "Seu mês grátis começa a contar no momento em que você clicar no botão abaixo."}
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          {!token && (
            <p className="text-sm text-destructive">Link inválido ou incompleto.</p>
          )}
          {error && <p className="text-sm text-destructive">{error}</p>}
          {claimed ? (
            <Button asChild className="w-full">
              <Link to="/dashboard">Ir para o painel</Link>
            </Button>
          ) : (
            <Button className="w-full" disabled={!token || loading} onClick={claim}>
              {loading ? "Ativando..." : "Ativar meu mês grátis"}
            </Button>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
